import { GroupLevelArkchatPermission } from "../utils/constant";

// Channels whose events this tab handles: every group/DM in the main list and
// in the archive (archived chats still get live messages), the user's private
// channel in each group, and the active account's signal channel (with "All"
// shown, every account's: changes in any of them show live). Groups the user
// was removed from are left out.
export function subscriptionChannels(groupList, archiveGroupList, currentUserData, allWorkspaces) {
  const channels = new Set();
  for (const group of [...(groupList || []), ...(archiveGroupList || [])]) {
    if (!group?.pnId) continue;
    if (group.isGroup && group.permissionType === GroupLevelArkchatPermission?.REMOVE) continue;
    channels.add(group.pnId);
    if (group.isGroup) channels.add(`${group.pnId}.user_${currentUserData?.id}`);
  }
  if (currentUserData?.activeSubscriber?.id) {
    channels.add(`subscriber_${currentUserData.activeSubscriber.id}.signal`);
  }
  if (allWorkspaces) {
    for (const account of currentUserData?.subscribedTo || []) {
      if (account?.id) channels.add(`subscriber_${account.id}.signal`);
    }
  }
  return [...channels];
}
